module.exports = __webpack_public_path__ + "static/media/maintenance.9eb354c6.svg";